import type { FC, SVGProps } from 'react';
import React from 'react';

import styles from './Spinner.module.scss';

type SpinnerProps = SVGProps<SVGSVGElement>;

export const Spinner: FC<SpinnerProps> = props => {
  return (
    <svg {...props} viewBox="0 0 50 50" className={styles.root}>
      <circle
        className={styles.circle}
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="4"
      />
    </svg>
  );
};
